export default {
	baseURL: window.env.REACT_APP_API,
	timeout: 0,
	headers: {
		Accept: "*/*",
	},
};
